export default class UsersService {
  constructor(Api) {
    "ngInject"
    this.api = Api;

  }

  loadUsers(data) {
    let
      url = '/users/list';
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  getUser(id) {
    return this.api.call({
      method: 'get',
      url: '/users/get/' + id
    })
  }

  getOrders(data) {
    let
      url = '/users/getOrders';
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  getComments(id) {
    return this.api.call({
      method: 'get',
      url: '/users/comments/' + id
    })
  }

  saveComments(data) {
    let
      url = '/users/saveComment';
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  removeComment(id) {
    let
      url = `/users/removeComment/${id}`;
    return this.api.call({
      method: 'delete',
      url
    })
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/users/services/user.service.js
 **/